import styled from 'styled-components';

export const FocusesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 10px 20px 20px;
`;
